// extracted by mini-css-extract-plugin
module.exports = {"fake-autocomplete":"fake-autocomplete___2jQJV","invalid":"invalid___35sNw","is-archived":"is-archived___2VxUk"};